import * as Sentry from 'sentry-expo';
import config from './Config';

// Sentry.init(config.sentry);
// Sentry.init({
//     dsn: 'xyz'
// });

export default Sentry;